import React from "react"
import styled from "styled-components"

import {CheckoutRedemption, DealType} from "@irati/types"
import GenericModal from "@irati/ui/src/GenericModal"
import MerchandiseSummary from "./MerchandiseSummary"
import PerkSummaryPopup from "./PerkSummaryPopup"

type Props = {
  show: boolean
  onHide: () => void
  redemption: CheckoutRedemption | null
}

export const SummaryPopup = ({redemption, show, onHide}: Props) => {
  if (!show) return null

  const {dealSnapshot} = redemption!

  if (dealSnapshot!.type === DealType.Merchandise) {
    return (
      <StyledModal show hideActions onHide={onHide}>
        <MerchandiseSummary redemption={redemption!} />
      </StyledModal>
    )
  }

  return <PerkSummaryPopup show redemption={redemption!} onHide={onHide} />
}

const StyledModal = styled(GenericModal)`
  .modal-content {
    background-color: ${({theme}) => theme.colors.greys.lightest};
  }
`
